// Copyright (c) Bentley Systems
export enum DawComponent {
  DAW_COMPONENT_GENERAL_PROJECTS = "DAW_COMPONENT_GENERAL_PROJECTS",
  DAW_COMPONENT_SUBSCRIBED_PROJECTS = "DAW_COMPONENT_SUBSCRIBED_PROJECTS",
  DAW_COMPONENT_SUBSCRIBED_ORGANIZATIONS = "DAW_COMPONENT_SUBSCRIBED_ORGANIZATIONS",
  DAW_COMPONENT_LINKAGE_ATTRIBUTE_FORM = "DAW_COMPONENT_LINKAGE_ATTRIBUTE_FORM",
  DAW_COMPONENT_EXTERNAL_VIEWS = "DAW_COMPONENT_EXTERNAL_VIEWS",
  DAW_COMPONENT_CREDENTIAL_LIST = "DAW_COMPONENT_CREDENTIAL_LIST",
  DAW_COMPONENT_MANAGE_ACCESS_ROLES_ASSIGNMENT_FORM = "DAW_COMPONENT_MANAGE_ACCESS_ROLES_ASSIGNMENT_FORM",
  DAW_COMPONENT_API_TESTING = "DAW_COMPONENT_API_TESTING",
  DAW_COMPONENT_ON_PREM_ROUTING = "DAW_COMPONENT_ON_PREM_ROUTING",
  DAW_COMPONENT_ON_PREM_ROUTING_TOGGLE = "DAW_COMPONENT_ON_PREM_ROUTING_TOGGLE",
  DAW_COMPONENT_ON_PREM_TELEMETRY = "DAW_COMPONENT_ON_PREM_TELEMETRY",
}
